export default __webpack_public_path__ + "static/media/PPI-steps-003.437f6d23.jpg";